export interface ApiResponse<T> {
  data: T
  message?: string
}

export interface PaginatedResponse<T> {
  data: T[]
  page: number
  page_size: number
  total: number
  total_pages: number
  message?: string
}

export interface ApiError {
  message: string
  code?: string
  status?: number
}

export interface Organization {
  id: number
  name: string
  tenant_id: string
  root_organization: boolean
  type: 'standard' | 'partner'
}

/** Root and partner organizations administer other organizations; standard
 *  (customer) organizations have no access to the admin tool, even over themselves. */
export function isAdminEligible(organization: Organization | undefined): boolean {
  return !!organization && (organization.root_organization || organization.type === 'partner')
}

export interface AuthenticatedUser {
  id: number
  first_name: string
  last_name: string
  cognito_subject: string
  email: string
  organization: Organization
}

export interface Profile {
  user: AuthenticatedUser
}
